















































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';
import CurpValidate from '@/util/curp';

export default Vue.extend({
  props: {
    datos: Array,
  },
  data: () => ({
    CondominoAgregado: {},
    openDialog: false,
    nuevoPropiet: {
      creationDateTime: '',
      creationUsername: '',
      curp: '',
      direccion: '',
      isPropietary: false,
      nombre: '',
      rfc: '',
    },
    loading: false,
    result: {},
    unidades: [],
    unidadSeleccionada: {},
    asociar: false,
    agregarContacto: false,
    nuevoContacto: {},
    contactoItems: [
      { text: 'E-mail', value: 'EMAIL' },
      { text: 'SMS', value: 'TEL' },
    ],
  }),
  methods: {
    ...mapActions(['getFree', 'validateRFC']),
    modeloPropiet() {
      return {
        creationDateTime: '',
        creationUsername: '',
        curp: '',
        direccion: '',
        isPropietary: false,
        nombre: '',
        rfc: '',
      };
    },
    resetPropiet() {
      this.nuevoPropiet = {
        creationDateTime: '',
        creationUsername: '',
        curp: '',
        direccion: '',
        isPropietary: false,
        nombre: '',
        rfc: '',
      };
    },
    async loadData() {
      try {
        this.result = {};
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.debug('datos getFreeMax: %o', datos);
        const result = await this.$store.dispatch('getFreeMax', datos);
        console.debug('result getFreeMax: %o', result);
        this.result = result;
        this.unidades = result.data.content;
        console.debug('unidades: %o', this.unidades);
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async AgregarPropiet(siguiente = false) {
      if (this.asociar && Object.keys(this.unidadSeleccionada).length === 0) {
        this.$toast.error('Seleccione una unidad');
        return;
      }
      if (this.agregarContacto && this.nuevoContacto.value.length === 0) {
        this.$toast.error('Introduzca la información del medio de contacto');
        return;
      }
      let propietarioAgregado = false;
      try {
        this.loading = true;
        this.nuevoPropiet.creationDateTime = this.$moment().format();
        this.nuevoPropiet.creationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const propietario = this.nuevoPropiet;
        let curpVal = {
          valid: true,
          data: '',
        };
        if (propietario.nombre === '') {
          this.$toast.error('Introduzca el nombre del propietario/inquilino');
          this.loading = false;
          return;
        }
        if (propietario.curp !== '') {
          curpVal = CurpValidate(propietario.curp);
          if (!curpVal.valid) {
            this.$toast.error(curpVal.data);
            this.loading = false;
            return;
          } else {
            propietario.curp = curpVal.data;
          }
        }
        if (this.nuevoPropiet.rfc !== '') {
          const value = this.nuevoPropiet.rfc.toUpperCase();
          try {
            const response = await this.$store.dispatch('validateRFC', {rfc: value});
            propietario.rfc = this.nuevoPropiet.rfc.toUpperCase();
          } catch (e) {
            console.error(e);
            this.$toast.error(e.response.data.message);
            // propietario.rfc = '';
            return;
          }
        }
        const datos = {admin, condo, propietario};
        console.log('datos: %o', datos);
        const result = await this.$store.dispatch('addPropietCondo', datos );
        this.CondominoAgregado = result.data;
        console.debug('Respuesta addPropietCondo: %o', result);
        this.$toast.success('Propietario agregado');
        propietarioAgregado = true;
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      try {
        if (!this.asociar) {
          this.unidadSeleccionada = {};
        } else {
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const periodo = this.formattedDate;
          const relacion = {
            condominio: condo,
            condomino: this.CondominoAgregado,
            unidades: this.unidadSeleccionada,
          };
          const propUnidad = {
            periodo,
            relacion,
          };
          const datos = {admin, condo, propUnidad};
          console.log('datos: %o', datos);
          const result = await this.$store.dispatch('asociarPropietCondo', datos);
          console.debug('Respuesta asociarPropietCondo: %o', result);
          this.$toast.success('Unidad y propietario asociados exitosamente');
        }
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      if (propietarioAgregado && this.agregarContacto) {
        this.AgregarContacto(this.CondominoAgregado);
      }
      this.loading = false;
      if (siguiente) {
        this.resetPropiet();
      } else {
        this.openDialog = false;
      }
      this.$emit('reload', {});
      this.loadData();
    },
    restrictChars($event) {
      if (this.nuevoContacto.tipo === 'TEL') {
        if (($event.charCode >= 48 && $event.charCode <= 57)) {
          return true;
        } else {
            $event.preventDefault();
        }
      } else if (this.nuevoContacto.tipo === 'EMAIL') {
        if ((this.nuevoContacto.value.indexOf('@') === -1) && ($event.charCode === 64)) {
          return true;
        } else if ($event.charCode !== 64) {
            return true;
        }
        $event.preventDefault();
      }
    },
    async AgregarContacto(propietario) {
      try {
        this.loading = true;
        this.nuevoContacto.creationDateTime = this.$moment().format();
        this.nuevoContacto.creationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const contacto = this.nuevoContacto;
        contacto.propietario = propietario;
        const datos = {admin, condo, propietario, contacto };
        console.debug('datos addContacto: %o', datos);
        const result = await this.$store.dispatch('addContacto', datos );
        console.debug('respuesta addContacto: %o', result);
        this.$toast.success('Contacto agregado');
      } catch (e) {
        this.$toast.error(e.response.data.message);
        console.error(e);
      }
      this.loading = false;
      this.nuevoContacto = this.modeloNuevoContacto();
    },
    modeloNuevoContacto() {
      return {
        creationDateTime: '',
        creationUsername: '',
        tipo: 'EMAIL',
        value: '',
      };
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.nuevoContacto = this.modeloNuevoContacto();
        this.loadData();
      }
      if (!this.openDialog) {
        this.nuevoPropiet = this.modeloPropiet();
        this.asociar = false;
        this.unidadSeleccionada = {};
      }
    },
  },
  computed: {
    formattedDate() {
      return this.$moment().format('YYYY-MM-DD');
    },
    contactTypeLabel() {
      if (this.nuevoContacto.tipo === 'EMAIL') {
        this.nuevoContacto.value = '';
        return 'Correo';
      } else if (this.nuevoContacto.tipo === 'TEL') {
        this.nuevoContacto.value = '';
        return 'Número de teléfono';
      } else {
        return 'Datos del contacto';
      }
    },
  },
});
